import { Audio, AudioStatusReasonType } from 'types/audio';

export const getSnackbarErrorText = (audio: Audio) => {
  if (audio.statusReason === AudioStatusReasonType.FAILURE) {
    return `"${audio.title}" upload failed unexpectedly, please retry.`;
  }
  if (audio.statusReason === AudioStatusReasonType.UNSUPPORTED_FILE_TYPE) {
    return `"${audio.title}" has unsupported file type, please try another type.`;
  }
  if (audio.statusReason === AudioStatusReasonType.REACHED_MAXIMUM_FILE_SIZE) {
    return `"${audio.title}" exceeded maximum allowed size, please try a smaller file.`;
  }
  return `"${audio.title}" upload failed unexpectedly, please retry.`;
};
